import React, { useState, useEffect } from "react";

import CustomDropDown from "./CustomDropDown";
import HeightInput from "./HeightInput";

const ProfileInput = ({
    loadedProfile,
    setProfile
}) => {
    const [bio, setBio] = useState("");
    const [gender, setGender] = useState(null);
    const [height, setHeight] = useState(null);
    const [language, setLanguage] = useState(null);
    const [payer_type, setPayerType] = useState(null);

    const genderOptions = [
        { label: "Female", value:0 },
        { label: "Male", value:1 },
        { label: "Nonbinary", value:2 }
    ];

    const languageOptions = [
        { label: "English", value:0 },
        { label: "Spanish", value:1 }
    ];

    const payerOptions = [
        { label: "Test", value: -3 },
        { label: "Demo", value: -2 },
        { label: "Research", value: -1 },
        { label: "Worker’s Compensation", value: 1 },
        { label: "Private Pay", value: 0 },
        { label: "Veteran’s Association", value: 2 },
        { label: "Personal Injury", value: 3 }
    ];

    // ---=== useEffects ===--- //

    useEffect(
        () => {
            if (loadedProfile){
                setHeight(loadedProfile.height);
                setBio(loadedProfile.bio);
                setGender(loadedProfile.gender);
                setLanguage(loadedProfile.language)
                setPayerType(loadedProfile.payer_type)

            }
        }, [loadedProfile])

    useEffect(
        () => {
            setProfile({
                height: height,
                gender: gender,
                language: language,
                payer_type: payer_type

            })
        }, [height, bio, gender,language,payer_type])

    // ---=== Render ===--- //

    return (
        <React.Fragment>
            <HeightInput
                initialHeight={loadedProfile?.height}
                // Callbacks
                setPatientHeight={setHeight}
            />
            <div className="h-[70px]  w-full  flex-col justify-start items-start gap-2 flex">
                <div className="self-stretch h-[70px] flex-col justify-start items-start gap-1.5 flex">
                    <div className="text-gray-700 text-sm font-medium  leading-tight">Gender</div>
                    {
                        (gender !== null) &&
                        (
                            <CustomDropDown
                                buttonFont={"font-normal"}
                                buttonTextColor="text-gray-500"
                                defaultValue={gender}
                                optionMaxHeight={"max-h-32"}
                                options={genderOptions}
                                // Callbacks
                                onSelectionCallback={setGender}
                            />
                        )
                    }

                </div>
            </div>
            <div className="h-[70px]  w-full  flex-col justify-start items-start gap-2 flex">
                <div className="self-stretch h-[70px] flex-col justify-start items-start gap-1.5 flex">
                    <div className="text-gray-700 text-sm font-medium  leading-tight">Language</div>
                    {
                        (language !== null) &&
                        (
                            <CustomDropDown
                                buttonFont={"font-normal"}
                                buttonTextColor="text-gray-500"
                                defaultValue={language}
                                optionMaxHeight={"max-h-32"}
                                options={languageOptions}
                                // Callbacks
                                onSelectionCallback={setLanguage}
                            />
                        )
                    }
                </div>
            </div>
            <div className="h-[70px] w-full flex-col justify-start items-start gap-2 flex">
                <div className="self-stretch w-full h-[70px] flex-col justify-start items-start gap-1.5 flex">
                    <div className="text-gray-700 w-full text-sm font-medium  leading-tight">Payer Type</div>
                    {
                        (payer_type !== null) &&
                        (
                            <CustomDropDown
                                buttonFont={"font-normal"}
                                buttonTextColor="text-gray-500"
                                defaultValue={payer_type}
                                optionMaxHeight={"max-h-32"}
                                options={payerOptions}
                                optionsJustifyBottom={false}
                                // Callbacks
                                onSelectionCallback={setPayerType}
                            />
                        )
                    }
                </div>
            </div>

        </React.Fragment>

    )

}

export default ProfileInput;
